<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data"  class="workflow-tabs">
                            <input type="hidden" name="_token" :value="csrf">
                            <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                            <div class="tab-content">
                                
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Settings Skills Personal</p>
                                    </div>
                                </div>
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.title")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]" :value="name">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.description")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[description]" :value="description">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.sorting")}}</label>
                                            <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="sorting">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label>Type</label>
                                            <select class="form-control rounded" name="questionSettings[type]" :value="type">
                                                <option value="title">Livelli</option>
                                                <option value="color">Colori</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label>Mostra affinità posizione</label>
                                            <input class=" rounded" name="questionSettings[show_affinity]" type="checkbox" value="1" v-model="showAffinity">
                                        </div>
                                    </div>
                                </div>
                                
                                
                                <div class="row mb-3">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-3">
                                                <h6>Delta</h6>
                                            </div>
                                            <div class="col-3">
                                                <h6>Color</h6>
                                            </div>
                                            <div class="col-3"></div>
                                        </div>
                                        <div class="row align-items-center p-2 mb-2" v-for="(color,key) in limit" :key="key">
                                            <div class="col-3">
                                                <h6>{{key}}</h6>
                                            </div>
                                            <div class="col-1">
                                                <input class="form-control rounded" :name="'questionSettings[limit]['+key+']'" type="color" :value="color">
                                            </div>
                                            <div class="col-8">
                                                <h6 v-if="limitDefault.includes(key)"></h6>
                                                <button v-else type="button" class="btn btn--only-icon-rounded btn--danger" @click="rmLimit(key)" ><i class="fas fa-trash"></i></button>
                                            </div>
                                        </div>
                                        <div class="row align-items-center p-2 mb-2">
                                            <div class="col-3">
                                                <h6>Non valutabile</h6>
                                            </div>
                                            <div class="col-1">
                                                <input class="form-control rounded" name="questionSettings[unset]" type="color" :value="unset">
                                            </div>
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                                
                                
                                <div class="form-buttons clear" v-if="can_write">
                                    <button class="btn btn--green" type="submit" > Submit</button>
                                </div>
                            </div>
                        </form>
                        
                        
                        <form class="workflow-tabs">
                            <div class="tab-content">
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Add new delta</p>
                                    </div>
                                </div>        
                                <div class="row align-items-center p-2 mb-2">
                                    <div class="col-3">
                                        <input class="form-control rounded" type="number" v-model="newDeltaNum" >
                                    </div>
                                    <div class="col-1">
                                        <input class="form-control rounded" type="color" v-model="newDeltaColor">
                                    </div>
                                    <div class="col-8 text-right">
                                    <button type="button" v-on:click="addDelta1" class="btn">Add new Delta</button>
                                        
                                    </div>
                                </div>
                               
                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    
    props: {
        can_write:{
            type:Boolean,
            required:true,
        }
    },
    data () {
        return {
            
            
            type: "title", // color
            limit : [],
            limitDefault : ["0","-10","10"],
            unset : "#A8A8A8",
            newDeltaNum : 0,
            newDeltaColor : "#FF00FF",
            //default
            title: "Skills / Activities Levels",
            active : false,
            showAffinity : false,
            action : "",
            name:"",
            description:"",
            sorting:-1,
            editing : true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        rmLimit(index){
            Vue.delete(this.limit,index);
        },
        addDelta1(){
            
            let cond1 = (this.newDeltaNum==='') ;
            let cond2 = (this.limit.hasOwnProperty(this.newDeltaNum)) ;
            
            
            if ( cond1 || cond2 ){
                alert("Delta is empty or is already set");
                return false;
            }
            Vue.set(this.limit,this.newDeltaNum,this.newDeltaColor); //Best method to do it
        },
        toggle(action, item_id, editing, attributes) {
            this.active     = true;
            this.action     = action;
            this.editing    = editing;
            this.lang       = attributes.lang;
            let dataRoute   = decodeURI(attributes.dataRoute);
            if (dataRoute!==undefined) {
                if (dataRoute.indexOf("[id]")>0) {
                    dataRoute = dataRoute.replace("[id]", item_id);
                }
                axios.get(dataRoute)
                .then((response) => {
                    
                    this.name = response.data.base.name;
                    this.description = response.data.base.description;
                    this.sorting = response.data.base.sorting;
                    this.type = response.data.settings.type;
                    this.limit = response.data.settings.limit;
                    this.unset = response.data.settings.unset;
                    this.showAffinity = response.data.settings.show_affinity;
                    this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);
                });
            }
        }
    }
}
</script>

